import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class IdiomaService {

  private idiomaSubject:BehaviorSubject<'pt-br' | 'en' | 'es'> = new BehaviorSubject<'pt-br' | 'en' | 'es'>('pt-br');
  idioma$: Observable<'pt-br'|'en'|'es'> = this.idiomaSubject.asObservable();

  constructor() { }

  alterarIdioma(idioma: 'pt-br' | 'en' | 'es'): void {
    if (['pt-br', 'en', 'es'].includes(idioma)) {
      this.idiomaSubject.next(idioma);
    } else {
      console.error('Idioma inválido:', idioma);
    }
  }
}
